import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';
// import heroMobileImage from '../../images/articles/wf_impact_isf_articles_ev-manufacturing_share.jpg';
import ModalOverlay from "../../components/ModalOverlay";

import { fireTag } from '../../libs/analytics.js';

import heroMobileImage from '../../images/articles/wf-isf-engaging_employees_on_sustainability_767x577.jpg';
import heroDesktopImage from '../../images/articles/wf-isf-engaging_employees_on_sustainability_1164x584.jpg';

import bodyDesktopImage from '../../images/articles/GBH_Earth_Day_InLIne_HALF_01_800x510.jpg';
import bodyMobileImage from '../../images/articles/GBH_Earth_Day_InLIne_HALF_01_800x510.jpg';

const Engaging = ({
					   uiState,
					   isMobile,
					   handleEvent,
					   modalOverlay,
					   closeExitOverlay,
					   addExitClickListeners,
				   }) => {

	const [enableScrollGA, setEnableScrollGA] = useState(false);
	const [shouldBeInert, setShouldBeInert] = useState(false);
	const [gridVisible, setGridVisible] = useState(false);
	const heroOGImage = 'wf_impact_isf_articles_ev-manufacturing_desktop.jpg';

	addExitClickListeners();

	const toggleInert = () => {
		setShouldBeInert(!shouldBeInert)
	}


	const toggleGrid = () => {
		const grid = document.getElementsByClassName('grid')[0];
		grid.style.display = (!gridVisible) ? 'none' : 'block';
		setGridVisible(!gridVisible)
	}

	const KonamiElement = () => {
		useKonami(toggleGrid, {
			code: [37, 39, 37, 39]
		});
		return <div className="grid" style={{display: gridVisible ? 'block' : 'none'}}/>;
	};

	const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];

				fireTag('A2',disclosureNumber);

				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});

				window.setTimeout(() => {
					// console.log(' ======== ');
					// console.log(targetElement);
					targetElement.focus();
				}, 1000);

			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}


	useEffect(() => {

		// console.log(`To see grid overlay, type ↑ ↑ ↓ ↓ ← → ← → B A inside the browser window`);
		ScrollToTop(setEnableScrollGA)
		linkDisclosures();

	}, []); // empty array says only use this effect once

	let mastheadImage;
	let bodyImage;

	switch (true) {
		case (window.innerWidth < 768):
			mastheadImage = heroMobileImage;
			bodyImage = bodyMobileImage;
			break;
		case (window.innerWidth < 1440):
			mastheadImage = heroDesktopImage;
			bodyImage = bodyDesktopImage;
			break;
		case (window.innerWidth >= 1440):
			mastheadImage = heroDesktopImage;
			bodyImage = bodyDesktopImage;
			break;
	}
	return (
		<>
			<Helmet>
				<title>Engaging employees on sustainability can make an impact</title>
				<meta
					name="description"
					content="Wells Fargo has realized sustainability-forward ideas suggested by employees since the 1970s energy crisis."
				/>
				<meta property="og:title" content="Engaging employees on sustainability can make an impact"/>
				<meta
					property="og:description"
					content="Wells Fargo has realized sustainability-forward ideas suggested by employees since the 1970s energy crisis."
				/>
				<meta property="og:image" content="https://welcome.wf.com/impact/images/articles/wf-isf-engaging_employees_on_sustainability_ogimage.jpg"/>
				<meta property="og:url" content={`https://welcome.wf.com/impact/sustainability/engaging-employees-on-sustainability/`}/>
				<meta property="twitter:title" content="Engaging employees on sustainability can make an impact"/>
				<meta
					property="twitter:description"
					content="Wells Fargo has realized sustainability-forward ideas suggested by employees since the 1970s energy crisis."
				/>
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}
			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>
			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}

			<main className={'flex-container'}>
				<div className="flex-row">
					<div className="flex-col-sm-12 flex-col-md-8 text-center headline">
						<h1 id="articles-main-h1">
							Engaging employees on sustainability can make an impact
						</h1>
						<h2 className="summary">
							Wells Fargo has realized sustainability-forward ideas suggested by employees since the 1970s energy crisis.
						</h2>
					</div>
				</div>
				<div className="flex-row full-width-md">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt={"Two female executives discuss business in a corporate office."}/>
					</div>
				</div>
				<div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center article-intro">
						<div className="by-line">
							<p>By Robyn Luhning, <span>chief sustainability officer at Wells Fargo</span></p>
						</div>
						<div className="article-info">
							<div>
								<p>March 28, 2024</p>
							</div>
							<div>
								<p>4-minute read</p>
							</div>
						</div>
						<p>
							Today, <a onClick={()=>fireTag('A1','more than ever')} target="_blank" href="https://www.businesswire.com/news/home/20230328005188/en/Despite-Budget-Cuts-on-ESG-76-of-U.S.-Employees-Say-Workplace-Sustainability-Is-More-Important-Than-Ever#:~:text=76%25%20of%20respondents%20said%20that%20sustainability%20practices%20and,to%20them%20than%20they%20were%20five%20years%20ago  " rel="noreferrer" data-click-listener="true">more than ever</a>, the workforce is interested in corporate sustainability. A <a onClick={()=>fireTag('A1','survey')} target="_blank" href="https://newsroom.ibm.com/2022-04-13-IBM-Global-Consumer-Study-Sustainability-Actions-Can-Speak-Louder-Than-Intent" rel="noreferrer" data-click-listener="true">survey</a> by IBM conducted across ten countries found two out of three respondents were more willing to apply for and accept jobs from organizations they consider to be environmentally sustainable.
						</p>
						<p>
							Employee interest in sustainability is not new. For decades, Wells Fargo employees have been a driving force in the company’s sustainability journey. Employees have a deep understanding of the organization’s values, and a keen viewpoint of how existing practices can be improved.
						</p>
						<p>
							At Wells Fargo, employee recommendations to launch recycling programs, pilot electric vehicle charging stations, and reduce single-plastic food service items have helped to advance sustainability across the company.
						</p>

						<h2 className="subhead">Employee-driven engagement results in real change</h2>
						<p>
							In 1970, during the U.S. energy crisis, Dennis Hart, a part-time administrative assistant, helped to start the company’s <a onClick={()=>fireTag('A1','first recycling program')} target="_blank" href="https://history.wf.com/how-a-few-team-members-spearheaded-recycling-in-the-1970s/" rel="noreferrer" data-click-listener="false">first recycling program</a>. Hart was inspired by an assignment to find a new vendor to dispose of trash at Wells Fargo Operations Center in San Francisco. At the time, the center was producing an average of 500,000 pounds of paper waste a year. Hart recognized an opportunity to improve business as usual by recycling. This led to the launch of new waste disposal practices that lowered trash removal expenses.
						</p>
						<div className="flex-row article-image">
							<img alt='In 1970, two Wells Fargo employees move a large bundle of shredded paper for recycling.' src={bodyImage}/>
							<p className="image-caption">Dennis Hart and Ed Landis gather paper waste headed to the recycling plant in 1970/Wells Fargo Corporate Archives</p>
						</div>

						<p>The first Wells Fargo recycling program is an example of the big impact employees can have at work, but many employees also want to live more sustainably at home.</p>

						<p>In 2013, a Des Moines-based employee suggested on-site charging stations for electric vehicles, or EVs, for employees. The company started a pilot program with nine charging stations in Iowa, Arizona, North Carolina, and Wisconsin. </p>

						<p>Longtime Minneapolis employee Leah Steahl was in the market for a new vehicle just as the EV chargers were installed. “We came across the EV and I had remembered, ‘Oh my goodness, I can charge it at work’,” Steahl recalls. “We did end up purchasing the car.” </p>

						<p>Today, Wells Fargo has free EV charging for employees at more than 30 facilities.</p>

						<h2 className="subhead">Employee concerns evolve over time</h2>

						<p>While reducing paper waste was a leading cause in the 1970s, plastic waste is now at the forefront of environmental action.</p>

						<p>Justin Williams, a member of Wells Fargo’s workplace experience team, recognized a desire among workers to limit their plastic waste. Williams spearheaded an initiative aimed at eliminating plastic bottled beverages across food service operations — such as employee cafes, micro markets, and vending machines.</p>

						<p>"I worked with our waste management team to understand what packaging is recycled in each market,” Williams said. “Based on that, we advised our food service operator on what beverage container materials would be best considering recycling capabilities at our locations."</p>

						<p>As of November 2023, plastic bottled beverages are no longer sold in most managed Wells Fargo locations. The plastic bottles were replaced with carton, can, and glass. The initiative is projected to help the company avoid over 30,000 pounds of plastic waste a year.</p>

						<p>The success of Wells Fargo's sustainability initiatives demonstrates the importance of listening to employees and empowering them to drive positive change. By fostering an environment where employees feel valued and heard, businesses can drive meaningful progress toward their sustainability goals.</p>

					</div>
				</div>
				{/*<KonamiElement className="grid"/>*/}
			</main>

			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>
			{/* Adobe retargeting tag */}
			{
				/*
					REMOVE TAG
						<img alt="" src="https://rtd-tm.everesttech.net/upi/?sid=s6cvr4h2qH04B3WUwCOG&cs=1" style={{display: 'none'}}/>
				*/
			}
			{modalOverlay && modalOverlay.open && (
				<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
			)}
		</>
	);
};

export default withRouter(Engaging);
